export default __webpack_public_path__ + "static/media/emptyHiredIcon.8f3ed993.svg";